import React from 'react'

/* Placeholder cards shown while the first page of a feed loads. */
export default function SkeletonCards({ count = 4 }) {
  return (
    <div aria-busy="true" aria-label="Učitavanje">
      {Array.from({ length: count }).map((_, i) => (
        <div className="card skeleton-card" key={i}>
          <div className="skeleton-main">
            <div className="skeleton-text">
              <div className="skeleton-line skeleton-meta" />
              <div className="skeleton-line" />
              <div className="skeleton-line skeleton-short" />
            </div>
            <div className="skeleton-thumb" />
          </div>
          <div className="skeleton-line skeleton-footer" />
        </div>
      ))}
    </div>
  )
}
